import { Translation } from '@ps/web-shared-components';
import { get } from 'lodash';
import React from 'react';
import type { CellProps, HeaderProps, Hooks } from 'react-table';

import SelectGame from '../GameTile/SelectGame/SelectGame';

import type { Props as CheckboxProps } from './IndeterminateCheckbox';
import IndeterminateCheckbox from './IndeterminateCheckbox';
import styles from './Table.scss';
import { TXTCLI_Select_All } from './TableAddons.messages.json';

export function renderSelectable<T extends object>(hooks: Hooks<T>) {
  hooks.visibleColumns.push((columns) => [
    {
      id: 'selection',
      Header: (props: React.PropsWithChildren<HeaderProps<T>>): JSX.Element => (
        <IndeterminateCheckbox
          {...props.getToggleAllRowsSelectedProps()}
          checkboxClassName={styles.selectAllCheckbox}
          name=""
          label={<Translation {...TXTCLI_Select_All} />}
          labelClasses={{ root: styles.selectAllLabelRoot, label: styles.selectAllLabel }}
        />
      ),
      Cell: ({ row }: CellProps<T>) => (
        <IndeterminateCheckbox {...(row.getToggleRowSelectedProps() as CheckboxProps)} />
      )
    },
    ...columns
  ]);
}

export function renderSelectGame<T extends object>(hooks: Hooks<T>) {
  hooks.visibleColumns.push((columns) => {
    const [firstColumn, ...rest] = columns;
    return [
      {
        ...firstColumn,
        Cell: ({ row }: CellProps<T>) => {
          const gameId = get(row, 'original.id');
          const { values } = row;
          const [firstCellKey] = Object.keys(values);
          return (
            <>
              <SelectGame id={gameId} listView /> {values[firstCellKey]}
            </>
          );
        }
      },
      ...rest
    ];
  });
}
